import styles from "./Dialog.module.css";

/*
 * `className` lets a caller adjust the footer's own spacing. A dialog whose body is a flex column
 * with a gap already separates the buttons from the last field, so the footer's margin lands on top
 * of that gap and doubles it — see the pregnancy forms.
 */
export const DialogFooter = ({ children, className }) => (
  <div className={className ? `${styles.footer} ${className}` : styles.footer}>
    {children}
  </div>
);
